import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function triggerEmailOtpData(payload) {
  try {
    const url = paths.triggerEmailOtp();
    const response = await axiosInstance.post(url, payload);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useTriggerEmailOtp = () => {
  return useMutation({
    mutationFn: triggerEmailOtpData,
  });
};

export { useTriggerEmailOtp };
